import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { rolesActionTypes } from '../reducer';

function* fetchRoles() {
  yield requestSaga({
    actionType: rolesActionTypes.getList,
    request: dataProvider.getList,
    resource: resources.role.index,
  });
}

export default [fetchRoles];
